// for compile time exhaustive flow errors
export function assertUnreachable(x: never): never {
  throw new Error("Reached unreachable code");
}
